import type { ComponentPropsWithRef } from 'react';

import { useTranslation } from 'react-i18next';

import { clsx } from '~/styles/utils';

import { listStyle, rootStyle } from './Breadcrumb.css';

type Props = ComponentPropsWithRef<'nav'>;

export const BreadcrumbRoot = ({ children, ...delegated }: Props) => {
  const { t } = useTranslation(['common']);

  return (
    <nav {...delegated} aria-label={t('common:breadcrumb')} className={clsx(rootStyle, delegated.className)}>
      <ol className={listStyle}>{children}</ol>
    </nav>
  );
};
